var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileVine3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 569,
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#065e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#328e72"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2048") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    display: "inline"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m51.55,541.56c-42.25,-24.65 -47.89,-85.21 -31.69,-133.8c16.2,-48.59 73.24,-49.3 95.07,-5.63c21.83,43.66 78.87,67.61 109.86,61.27c30.99,-6.34 34.51,-35.92 11.27,-49.3c-23.24,-13.38 -125.35,-88.73 -144.37,-109.15c-19.01,-20.42 -51.41,-80.28 -1.41,-97.18c50,-16.9 114.79,117.61 150.7,97.18c35.92,-20.42 35.92,-226.76 -31.69,-213.38c-67.61,13.38 -84.33,68.13 -147.8,63.2c-63.47,-4.93 -67.69,-69.19 -0.79,-100.53c133.8,-62.68 214.79,-33.1 236.48,3.51c21.69,36.61 14.23,419.03 -9.86,469.72c-24.08,50.69 -193.52,38.75 -235.77,14.1z",
    fill: "#ff0000",
    fillOpacity: 0.01,
    id: "svg_17",
    stroke: "#f90000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileVine3);
export default __webpack_public_path__ + "static/media/mobileVine3.eb704838af56a5efb7e26bdfb4184ef3.svg";
export { ForwardRef as ReactComponent };